import React from 'react'

import Spinner from 'components/Spinner'

import useLibraries from 'hooks/useLibraries'

import styled from 'styled-components'

import { LICENSE_DETAILS } from 'helpers/open_source_third_party_library'
import { color } from 'styles/colors'

const LibraryDetails = () => {
  const { libraries, isLoaded } = useLibraries()

  if (!isLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <div>
      {Object.values(libraries || {}).map(({ name, licenses, repository }) => {
        return (
          <div key={name}>
            <S.LibraryName>{name} </S.LibraryName>
            <span>License :
              <S.Link href={`#${licenses}`}>{licenses}</S.Link>
            </span>
            <div>{`Repository : ${repository}`} </div>
          </div>
        )
      })}
      <br />
      {Object.keys(LICENSE_DETAILS).map((name) => {
        return (
          <React.Fragment key={name}>
            <br />
            <S.LicenseHeader id={name}>{name}</S.LicenseHeader>
            <S.LicenseDescription>{LICENSE_DETAILS[name]}</S.LicenseDescription>
          </React.Fragment>
        )
      })
      }
    </div>
  )
}

export default LibraryDetails

const S = {
  LibraryName: styled.div`
  color: ${color('headerText')};
  margin-top: 10px;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 1.1em;
  `,
  Link: styled.a`
  padding-left: 5px
  `,
  LicenseHeader: styled.div`
  color: ${color('headerText')};
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 0.5rem;
  `,
  LicenseDescription: styled.p`
  white-space: pre-wrap;
  width: 90%;
  padding-left:20px;
  min-width: 400px;
  `

}
